const PreventiveMaintenance = {
    "list_title": "Preventive Job Order",

    // Table Headers
    "serial_no": "S No.",
    "job_order_no": "Job Order No.",
    "asset_code": "Asset Code",
    "item": "Item",
    "department": "Department",
    "location": "Location",
    "priority": "Priority",
    "start_date": "Start Date",
    "status": "STATUS",
    "action": "ACTION",

    // Status Badges
    "status_completed": "Completed",
    "status_paused": "Paused",
    "status_pending": "Pending",
    "status_upcoming": "Upcoming",
    "status_hold": "Hold",
    "status_stop": "Stop",

    // Modals
    "asset_details_title": "Asset Details",
    "job_order_details_title": "Job Order Details",
    "reason_title": "Reason",
    "reschedule_title": "Re-Schedule Date",
    "maintenance_report_title": "Maintenance Report",

    // Form/Actions
    "submit": "Submit",
    "filter_tooltip": "Filter",
    "pdf_tooltip": "Download PDF",
    "excel_tooltip": "Download Excel",
    "enter_reason_placeholder": "Enter Reason",
    "choose_date_placeholder": "Choose Date",

    // Messages
    "reschedule_success": "Maintenance Re-Schedule Successfully",
    "maintenance_success": "Maintenance Successfully",
    "bad_request": "400 Bad Request",
    "something_wrong": "Something went wrong",
}

export default PreventiveMaintenance;
